













import Vue from 'vue'
import XInput from '@/components/atoms/Input/XInput.vue'

type Method = {
  onBlur: () => void
}

type Props = {
  required: boolean
  value?: string
}

type Computed = {
  rules: string
  tel: string | undefined
}

export default Vue.extend<{}, Method, Computed, Props>({
  name: 'XTel',
  components: { XInput },
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    rules(): string {
      if (this.required) {
        return 'required|tel'
      }
      return 'tel'
    },
    tel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onBlur() {
      if (this.value) {
        this.tel = this.value.replaceAll('-', '')
      }
    },
  },
})
